import { render, staticRenderFns } from "./PropertyProjects.vue?vue&type=template&id=38c36ec4&scoped=true"
import script from "./PropertyProjects.vue?vue&type=script&lang=js"
export * from "./PropertyProjects.vue?vue&type=script&lang=js"
import style0 from "./PropertyProjects.vue?vue&type=style&index=0&id=38c36ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c36ec4",
  null
  
)

export default component.exports